// src/app/modules/Visitors/pages/visitors-table/column-formatters/VisitorColumnFormatter.jsx
import React from "react";
import { User, Mail, Phone } from 'lucide-react';

export function VisitorColumnFormatter(cellContent, row) {
  const primaryName = row.known_names && row.known_names.length > 0
    ? row.known_names[0].name
    : 'Unknown Visitor';

  const hasMultipleNames = row.known_names && row.known_names.length > 1;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <div style={{
        width: 34, height: 34, borderRadius: '50%', flexShrink: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'var(--purple-50)', color: 'var(--purple-500)',
      }}>
        <User size={16} />
      </div>
      <div>
        <div style={{ fontWeight: 600, fontSize: 14, display: 'flex', alignItems: 'center', gap: 6 }}>
          {primaryName}
          {hasMultipleNames && (
            <span className="sety-pill sety-pill-amber">+{row.known_names.length - 1} alias</span>
          )}
        </div>
        {row.visitor_phone && (
          <div className="sety-tbl-sub" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <Phone size={12} />{row.visitor_phone}
          </div>
        )}
        {row.visitor_email && (
          <div className="sety-tbl-sub" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <Mail size={12} />{row.visitor_email}
          </div>
        )}
      </div>
    </div>
  );
}
